module.exports = __webpack_public_path__ + "static/media/hitachi-abb.f6c84369.png";